import React from 'react';
import { CheckCircle } from 'lucide-react';

const MenuManagement = ({ menuItems, addMenuItem, removeMenuItem }) => {
  return (
    <div className="bg-white/5 backdrop-blur-xl rounded-3xl border border-white/10 p-8 mb-8 shadow-2xl">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-white">Menu Management</h2>
        <button
          onClick={addMenuItem}
          className="group flex items-center gap-3 px-6 py-3 rounded-2xl font-semibold bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600 text-white transition-all transform hover:scale-105 active:scale-95 shadow-lg shadow-green-500/25"
        >
          <div className="p-1 rounded-full bg-white/20">
            <CheckCircle className="w-4 h-4" />
          </div>
          Add Item
        </button>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.entries(menuItems).map(([key, item]) => (
          <div key={key} className="bg-black/20 backdrop-blur rounded-2xl p-6 border border-white/10 hover:border-white/20 transition-colors">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-xl font-bold text-white mb-2">{item.name}</h3>
                <p className="text-2xl font-bold text-green-400">${item.price.toFixed(2)}</p>
              </div>
              <button
                onClick={() => removeMenuItem(key)}
                className="text-red-400 hover:text-red-300 transition-colors"
              >
                ✕
              </button>
            </div>
            <div className="space-y-2">
              <p className="text-sm font-semibold text-gray-300">Options:</p>
              <div className="flex flex-wrap gap-2">
                {item.options.map((option, idx) => (
                  <span key={idx} className="px-3 py-1 bg-white/10 rounded-full text-xs text-gray-300">
                    {option}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuManagement; 